import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import Shop from "../src/Pages/Shop";
import Contact from "../src/Pages/Contact";
import Blog from "../src/Pages/Blog";
import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import ProductDetails from "./Pages/ProductDetails";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./Components/ScrollButton/ScrollToTop";
import Authentication from "./Pages/Authentication";
import ResetPass from "./Components/Authentication/Reset/ResetPass";
import BlogDetails from "./Components/Blog/BlogDetails/BlogDetails";
import TermsConditions from "./Pages/TermsConditions";
import ShoppingCart from "./Components/ShoppingCart/ShoppingCart";
// import Popup from "./Components/PopupBanner/Popup";
import { Toaster } from "react-hot-toast";
import Product3DDetails from "./Pages/Product3DDetails";
import { useDispatch } from "react-redux";
import { initializeCart } from "../src/Features/Cart/cartSlice";
import Profile from "./Components/User/Profile/Profile";
import Orders from "./Components/User/Orders/Order";
import AdminDashboard from "./Components/Admin/Dashboard/AdminDashboard";
import ManageProduct from "./Components/Admin/ManageProduct/ManageProduct";
import ManageOrder from "./Components/Admin/ManageOrder/ManageOrder";
import EditProduct from "./Components/Admin/EditProduct/EditProduct";
import DashboardHome from "./Components/Admin/DashboardHome/DashboardHome";
import AddProduct from "./Components/Admin/ManageProduct/AddProduct/AddProduct";
import ManageUser from "./Components/Admin/ManageUser/ManageUser";
import ViewUser from "./Components/Admin/ManageUser/ViewUser/ViewUser";
import ViewOrder from "./Components/Admin/ManageOrder/ViewOrder/ViewOrder";
import EditOrder from "./Components/Admin/ManageOrder/EditOrder/EditOrder";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const storedCart = JSON.parse(localStorage.getItem("cart"));
      if (Array.isArray(storedCart)) {
        dispatch(initializeCart(storedCart));
      }
    } catch (e) {
      console.error("Failed to load cart from localStorage", e);
    }
  },);
  return (
    //   <>
    //     {/* <Popup /> */}
    //     <ScrollToTop />
    //     <BrowserRouter>
    //       <Header />
    //       <Routes>
    //         <Route path="/" element={<Home />} />
    //         <Route path="/about" element={<About />} />
    //         <Route path="/shop" element={<Shop />} />
    //         <Route path="/contact" element={<Contact />} />
    //         <Route path="/blog" element={<Blog />} />
    //         <Route path="/product" element={<ProductDetails />} />
    //         <Route path="/3d-product/:id" element={<Product3DDetails />} />
    //         <Route path="/loginSignUp" element={<Authentication />} />
    //         <Route path="/resetPassword" element={<ResetPass />} />
    //         <Route path="/BlogDetails" element={<BlogDetails />} />
    //         <Route path="/terms" element={<TermsConditions />} />
    //         <Route path="/cart" element={<ShoppingCart />} />
    //         <Route path="/profile" element={<Profile />} />
    //         <Route path="/orders" element={<Orders />} />
    //         <Routes>
    // {/* Admin routes */}
    // <Route path="/admin" element={<AdminDashboard />}>
    //   <Route path="products" element={<ManageProduct />} />
    //   <Route path="edit-product/:id" element={<EditProduct />} />
    //   <Route path="orders" element={<ManageOrder />} />
    //   {/* You can add more like: <Route path="users" element={<ManageUser />} /> */}
    // </Route>
    //         <Route path="*" element={<NotFound />} />
    //       </Routes>
    //       <Footer />
    //       <Toaster />
    //     </BrowserRouter>
    <>
      {/* <Popup /> */}
      <ScrollToTop />
      <BrowserRouter>
        <Header />

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/product" element={<ProductDetails />} />
          <Route path="/3d-product/:id" element={<Product3DDetails />} />
          <Route path="/loginSignUp" element={<Authentication />} />
          <Route path="/resetPassword" element={<ResetPass />} />
          <Route path="/BlogDetails" element={<BlogDetails />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cart" element={<ShoppingCart />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/orders" element={<Orders />} />

          <Route path="/admin" element={<AdminDashboard />}>
            {/* ✅ Default route for /admin */}
            <Route index element={<DashboardHome />} />

            {/* ✅ Other admin child routes */}
            <Route path="products" element={<ManageProduct />} />
            <Route path="edit-product/:id" element={<EditProduct />} />
            <Route path="orders" element={<ManageOrder />} />
            <Route path="orders/:id" element={<ViewOrder />} />
            <Route path="orders/edit-orders/:id" element={<EditOrder />} />
            <Route path="users" element={<ManageUser />} />
            <Route path="users/:id" element={<ViewUser />} />
            <Route path="add-product" element={<AddProduct />} />
            {/* Add more like users, payments */}
          </Route>

          {/* 404 - Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
        <Toaster />
      </BrowserRouter>
    </>

    //   </>
  );
};

export default App;
